import styled from 'styled-components';
import {motion} from 'framer-motion';

const DrawerContainer = styled(motion.div)`
  position: fixed;
  right: 0;
  top: ${({ top }) => (typeof top === 'number' ? `${top}px` : top)};
  width: ${({ width }) => (typeof width === 'number' ? `${width}px` : width)};
  height: 100vh;
  box-shadow: ${({ boxShadow }) => boxShadow};
  z-index: 1000;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
`;

export {
  DrawerContainer
}
